<template>
  <div :class="computedClass">
    <div class="i-page-close">
      <i-btn v-if="!hideClose" dense color="negative" fab flat round v-close-popup tooltip-text="关闭" :glossy="false" >
        <q-icon size="lg" name="cancel" />
      </i-btn>
      <!-- <i-btn v-if="!hideClose" dense icon="cancel" color="negative" fab flat round v-close-popup tooltip-text="关闭" :glossy="false" /> -->
    </div>
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    hideClose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedClass () {
      return `i-page ${this.$q.dark.isActive ? 'q-dark' : 'i-page-light'} panel-border`
    }
  }
}
</script>

<style lang="scss">
.i-page {
  position: relative;
}
.i-page-close {
  position: absolute;
  top: 0;
  right: 0;
}
.i-page-light {
  background-color: var(--i-color-theme-bg);
}
</style>
